import { createElement, lazy, StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter, Route, Routes } from "react-router";
import "./index.css";
import { AuthProvider } from "./context/AuthContext.tsx";
import { PrivateRoute } from "./components/auth/PrivateRoute.tsx";
import { PERMISOS } from "./constants/permissions.ts";
import { Toaster } from "./components/ui/sonner";
import { MasterDataLayout } from "./components/master-data/MasterDataLayout.tsx";
import {
  getEnabledRouteEntries,
  toRelativeRoutePath,
} from "./config/routes.ts";
import { ROUTE_PAGES } from "./config/route-pages.tsx";

const Home = lazy(() => import("./pages/Home.tsx"));
const LoginPage = lazy(() => import("./pages/Login.tsx"));
const FilingPage = ROUTE_PAGES.filing!;

const appRoutes = getEnabledRouteEntries().filter(({ id }) => ROUTE_PAGES[id]);

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<LoginPage />} />

          <Route
            path="/"
            element={
              <PrivateRoute>
                <MasterDataLayout>
                  <Home />
                </MasterDataLayout>
              </PrivateRoute>
            }
          >
            {/* Página principal - Radicación de facturas */}
            <Route
              index
              element={
                <PrivateRoute
                  requiredPermission={
                    PERMISOS.RADICACION_DE_FACTURAS.VER_RADICACION
                  }
                >
                  <FilingPage />
                </PrivateRoute>
              }
            />

            {appRoutes.map(({ id, route }) => {
              const Page = ROUTE_PAGES[id]!;
              return (
                <Route
                  key={id}
                  path={toRelativeRoutePath(route.path)}
                  element={
                    <PrivateRoute requiredPermission={route.permission}>
                      {createElement(Page)}
                    </PrivateRoute>
                  }
                />
              );
            })}
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster />
    </AuthProvider>
  </StrictMode>,
);
